import {
  MANAGE_COMPANY_LIST_PATH,
  MANAGE_PRODUCT_AND_SERVICE_PATH,
  OPENSEARCH_RESULT,
  PROJECT_REGISTRATION_PATH,
  VIEW_COMPANY_ABSOLUTE_PATH,
} from 'constant/appPath';
import Application from 'page/Application';
import ManageProductAndService from 'page/Application/ManageProductAndService';
import TopPageViewSuperDetailProduct from 'page/Application/ManageProductAndService/TopPageProduct/TopPageViewProductSuperDetail';
import {
  DetailNotifyPartnerAdmin,
  TopPageNotifyDetailPartnerAdmin,
  TopPagePartnerAdmin,
  TopPageProductDetailPartnerAdmin,
  TopPageProductSuperDetailPartnerAdmin,
} from 'page/Application/ManageProductAndService/TopPageProductPartnerAdmin';
import TopPageProductSolitonUser from 'page/Application/ManageProductAndService/TopPageProductSolitonUser/index';
import MyPage, { MyPageEdit, MyPageOverview } from 'page/Application/MyPage';
import PartnerWebsite, {
  PartnerWebsiteEdit,
  PartnerWebsiteOverView,
} from 'page/Application/PartnerWebsite';
import PartnerWebsiteDetail from 'page/Application/PartnerWebsite/PartnerWebsiteDetail';
import NotFound from 'page/NotFound';

import OpensearchResult from 'page/Application/Opensearch/OpensearchResult';
import {
  ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
  RESET_PASSWORD_PATH,
  SIGN_IN_PATH,
  SIGN_UP_VERIFY_EMAIL_PATH,
  SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
} from 'constant/authenticationPath';
import ResetPassword from 'page/Authentication/ForgotPassword/ResetPassword';
import ProjectPreviewSolitonAdmin, {
  ProjectDetail,
  ProjectPreview,
} from 'page/Application/ProjectPreviewSolitonAdmin';
import Authentication from 'page/Authentication';
import SignIn from 'page/Authentication/SignIn';
import SignUpVerifyEmail from 'page/Authentication/SignUpVerifyEmail';
import SuccessConfirmSignupEmail from 'page/Authentication/SuccessConfirmSignupEmail';
import ErrorConfirmSignupEmail from 'page/Authentication/ErrorConfirmSignupEmail';
import ManageCompanyList, {
  CompanyList,
  EditCompany,
} from 'page/Application/ManageCompanyList';

export const solitonUserRouterData = [
  {
    path: '/',
    element: <Application />,
    errorElement: <NotFound />,
    children: [
      {
        path: '/partner-page/:partnerId',
        element: <PartnerWebsite />,
        children: [
          {
            index: true,
            element: <PartnerWebsiteOverView />,
          },
          {
            path: `/partner-page/:partnerId/edit`,
            element: <PartnerWebsiteEdit />,
          },
          {
            path: `/partner-page/:partnerId/detail/:noticeId`,
            element: <PartnerWebsiteDetail />,
          },
        ],
      },
      {
        path: MANAGE_COMPANY_LIST_PATH,
        element: <ManageCompanyList />,
        children: [
          {
            index: true,
            element: <CompanyList />,
          },
          {
            path: VIEW_COMPANY_ABSOLUTE_PATH,
            element: <EditCompany />,
          },
        ],
      },
      {
        path: 'my-page',
        element: <MyPage />,
        children: [
          {
            index: true,
            element: <MyPageOverview />,
          },
          {
            path: `edit`,
            element: <MyPageEdit />,
          },
        ],
      },
      {
        path: 'top-page',
        element: <TopPageProductSolitonUser />,
        children: [
          {
            index: true,
            element: <TopPagePartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId',
            element: <TopPageProductDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/list-notify/:productId',
            element: <DetailNotifyPartnerAdmin />,
          },
          {
            path: 'top-page-product/list-notify/:productId/notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId/notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId/top-page-detail-product/:menuId',
            element: <TopPageProductSuperDetailPartnerAdmin />,
          },
          {
            path: 'top-page-product/:productId/top-page-detail-product/:menuId/detail/:detailId',
            element: <TopPageViewSuperDetailProduct />,
          },
          {
            path: 'list-notify',
            element: <DetailNotifyPartnerAdmin />,
          },
          {
            path: 'notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
          {
            path: 'list-notify/notify-detail/:notifyId',
            element: <TopPageNotifyDetailPartnerAdmin />,
          },
        ],
      },
      {
        path: MANAGE_PRODUCT_AND_SERVICE_PATH,
        element: <ManageProductAndService />,
      },
      {
        path: PROJECT_REGISTRATION_PATH,
        element: <ProjectPreviewSolitonAdmin />,
        children: [
          {
            index: true,
            element: <ProjectPreview />,
          },
          {
            path: 'detail/:projectId',
            element: <ProjectDetail />,
          },
        ],
      },
      // this router doesn't mention in document
      // {
      //   path: MANAGE_NOTIFICATION_PATH,
      //   element: <ManageNotificationList />,
      // },
      {
        path: OPENSEARCH_RESULT,
        element: <OpensearchResult roleType={'solitonUser'} />,
      },
    ],
  },
  {
    path: '/',
    element: <Authentication />,
    errorElement: <NotFound />,
    children: [
      {
        path: SIGN_IN_PATH,
        element: <SignIn />,
      },
      {
        path: SIGN_UP_VERIFY_EMAIL_PATH,
        element: <SignUpVerifyEmail />,
      },
      {
        path: SUCCESS_CONFIRM_SIGNUP_EMAIL_PATH,
        element: <SuccessConfirmSignupEmail />,
      },
      {
        path: ERROR_CONFIRM_SIGNUP_EMAIL_PATH,
        element: <ErrorConfirmSignupEmail />,
      },
    ],
  },
  {
    path: RESET_PASSWORD_PATH,
    element: <ResetPassword />,
  },
  {
    path: '404',
    element: <NotFound />,
  },
];
